export default __webpack_public_path__ + "static/media/aboutUsBgPattern.742656fd.png";